import * as React from "react";
import { useSelector } from "react-redux";

import { ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";
import { LocalizerContext } from "@com.mgmtp.a12.utils/utils-localization-react/lib/main";
import { MessageBox } from "@com.mgmtp.a12.widgets/widgets-core/lib/message-box";

import { SmallBoxLayout } from "../../component/SmallBoxLayout";
import { RESOURCE_KEYS } from "../../localization";

const CONTENT_RESOURCE_KEYS = RESOURCE_KEYS.application.content;

export const EmptyPortalPage: React.ComponentType<View> = function EmptyPortalPage(props) {
	const noAccess = useSelector(ActivitySelectors.activityPropById(props.activityId, it => it.descriptor.noAccess));

	const { localizer } = React.useContext(LocalizerContext);
	const contentKey = noAccess === "true" ? "noAccess" : "noPublications";

	return (
		<SmallBoxLayout
			content={
				<MessageBox variant="info" label={localizer({ key: CONTENT_RESOURCE_KEYS[contentKey].label })}>
					{localizer({ key: CONTENT_RESOURCE_KEYS[contentKey].content })}
				</MessageBox>
			}
		/>
	);
};
